import React, { useState } from "react";
import CustomButton from "../../components/CustomButton/custombutton";
import MenuCategory from "./Category/MenuCategory/MenuCategory";
import MenuList from "./Category/MenuList/MenuList";
import SubCategory from "./Category/SubCategory/SubCategory";
import "./product.css";

const Product = () => {
  let orgLevel = localStorage.getItem("orgLevel");
  const [activeTab, setActiveTab] = useState("Menu Categories");
  const tabTextMap = {
    1: { category: "Room", subCategory: "Room Type", menuList: "Room List" },
    2: { category: "Service", subCategory: "Service Type", menuList: "Service List" },
    3: { category: "Category", subCategory: "Sub Category", menuList: "Menu List" }
  }
  const changeActiveTabHandler = (newTab) => {
    setActiveTab(newTab);
  };

  return (
    <div className="product">
      <div className="menuBtnList">
        <CustomButton
          text={tabTextMap[orgLevel] ? tabTextMap[orgLevel].category : ""}
          addIcon={false}
          className={`btnMenu ${activeTab === "Menu Categories" ? "active" : ""
            }`}
          onClick={() => changeActiveTabHandler("Menu Categories")}

        />

        <CustomButton
          text={tabTextMap[orgLevel] ? tabTextMap[orgLevel].subCategory : ""}
          addIcon={false}
          className={`btnMenu ${activeTab === "Sub Categories" ? "active" : ""
            }`}
          onClick={() => changeActiveTabHandler("Sub Categories")}
        />
        <CustomButton
          text={tabTextMap[orgLevel] ? tabTextMap[orgLevel].menuList : ""}
          addIcon={false}
          className={`btnMenu ${activeTab === "Menu List" ? "active" : ""}`}
          onClick={() => changeActiveTabHandler("Menu List")}
        />
      </div>
      {activeTab === "Menu Categories" && <MenuCategory />}

      {activeTab === "Sub Categories" && <SubCategory />}

      {activeTab === "Menu List" && <MenuList />}
    </div>
  );
};

export default Product;
